import { Observable } from "rxjs";

export abstract class SmartTableData {
  abstract getData(pestab: string, pdt_ini: Date, pdt_fim: Date, pnmarq: number, pmesano: number): Observable<any>;
}


